module.exports = __webpack_public_path__ + "static/media/gen_img50.e3813074.png";